import Vue from 'vue';
import VueRouter, { Route } from 'vue-router';
import { AuthorisationManager } from './authorisation'

export interface IRouterAuthorisationConfig {
  router: VueRouter;
  signInUrl?: string;
}

export default function install(vue: typeof Vue, config: IRouterAuthorisationConfig) {
  config.router.beforeEach(async (to: Route, from: Route, next: any) => {
    if (to.matched.some(record => record.meta.auth)) {
      let isAuthenticated = await AuthorisationManager.IsAuthenticated();
      if (!isAuthenticated) {
        window.top.location.href = config.signInUrl ? config.signInUrl : '/#/signin';
      } else {
        next();
      }
    } else {
      next();
    }
  });
}



// WEBPACK FOOTER //
// src/../~/wc-lib/src/wc-authorisation/router-authorisation.ts